import {
  countryOptions,
  disposerOptions,
  euralOptions,
  hazardousOptions,
  locationOptions,
  materialOptions,
  processOptions,
  processorOptions,
  projectOptions,
  radiusOptions,
} from './mockOptions';

import type { NewFiltersOptions } from './types';

export const STORAGE_KEY = 'filters';

/** Static option values currently used by the new filters bar. */
export const NEW_FILTERS_OPTIONS: NewFiltersOptions = {
  countries: countryOptions,
  disposers: disposerOptions,
  eurals: euralOptions,
  hazardous: hazardousOptions,
  locations: locationOptions,
  materials: materialOptions,
  processes: processOptions,
  processors: processorOptions,
  projects: projectOptions,
  radius: radiusOptions,
};
